// API del configuratore Riserva d'Ingresso (CSP-2964).
// Thin client verso il BFF (os-bff -> os-sinistri). Usa lo stesso axiosInstance/executor
// del resto dell'app: header Authorization/refresh token gestiti dagli interceptor.
import axiosInstance from '../../data/axiosInstance/axiosInstance';
import executor from '../../data/axiosInstance/executor';

const BASE = `${process.env.REACT_APP_API_SINISTRI_URL}/api/v1/bff/regole-riserva-ingresso`;

// Elenco regole (paginato lato BFF/sinistri). Ritorna [res, err] come da executor.
export const fetchRegole = (filtri = {}) => {
  const params = new URLSearchParams();
  if (filtri.codiceProdotto) params.append('codiceProdotto', filtri.codiceProdotto);
  if (filtri.lob) params.append('lob', filtri.lob);
  if (filtri.ramo) params.append('ramo', filtri.ramo);
  if (filtri.geografia) params.append('geografia', filtri.geografia);
  if (filtri.attiva !== undefined && filtri.attiva !== null && filtri.attiva !== '') {
    params.append('attiva', filtri.attiva);
  }
  params.append('page', '0');
  params.append('size', '100');
  const query = params.toString();
  return executor.executeAsync(() => axiosInstance.get(query ? `${BASE}?${query}` : BASE));
};

export const fetchGeografie = () =>
  executor.executeAsync(() => axiosInstance.get(`${BASE}/geografie`));

export const createRegola = (dto) =>
  executor.executeAsync(() => axiosInstance.post(BASE, dto));

export const creaVersione = (dto) =>
  executor.executeAsync(() => axiosInstance.post(`${BASE}/versione`, dto));

export const updateRegola = (id, dto) =>
  executor.executeAsync(() => axiosInstance.put(`${BASE}/${id}`, dto));

export const disattivaRegola = (id) =>
  executor.executeAsync(() => axiosInstance.put(`${BASE}/${id}/disattiva`));

// Estrae il messaggio "parlante" dal valore di errore restituito dall'interceptor
// (che rigetta gia' con error.response.data: stringa JSON oppure oggetto).
export const messaggioErrore = (err) => {
  if (!err) return 'Errore imprevisto';
  if (typeof err === 'string') {
    try {
      return JSON.parse(err).message || err;
    } catch {
      return err;
    }
  }
  return err.message || 'Errore imprevisto';
};

// Formattazione data robusta a epoch-millis o stringa ISO (dipende dalla config Jackson di os-sinistri).
export const formatData = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('it-IT');
};
